export default __webpack_public_path__ + "static/media/home_banner.cb5c0351.png";